/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { WhiteSpace } from "antd-mobile";
import StarRatingComponent from "react-star-rating-component";
import "./index.css";
import Theme from "../../utils/Theme";

const StyledContentContainer = styled.div`
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  width: 100%;
  background: white;
  overflow: hidden;
  padding: 10px 20px;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 10px;
`;

const StyledSpaceBetweenContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

const StyledNameContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const StyledName = styled.span`
  font-size: 0.8em;
  color: gray;
`;

const StyledDate = styled.span`
  margin-left: 8px;
  font-size: 0.7em;
  color: lightgrey;
`;

const StyledRatingContainer = styled.div`
  font-size: 0.7em;
`;

const StyledTitle = styled.span`
  text-align: start;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: bold;
  font-size: 1em;
  color: black;
`;

const StyledDescription = styled.span`
  text-align: start;
  width: 100%;
  overflow: hidden;
  font-size: 1em;
  color: black;
`;

class ReviewItem extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { id, name, date, rating, title, description } = this.props;

    return (
      <StyledContentContainer>
        <StyledSpaceBetweenContainer>
          <StyledNameContainer>
            <StyledName>{name}</StyledName>
            <StyledDate>{date}</StyledDate>
          </StyledNameContainer>
          <StyledRatingContainer>
            <StarRatingComponent
              name={"productItemRating"}
              editing={false}
              starCount={5}
              value={rating}
              starColor={Theme.PrimaryColor}
              emptyStarColor={"lightgrey"}
            />
          </StyledRatingContainer>
        </StyledSpaceBetweenContainer>
        {/*<WhiteSpace size={"sm"} />*/}
        {/*<StyledTitle>{title}</StyledTitle>*/}
        <WhiteSpace size={"sm"} />
        <StyledDescription>{description}</StyledDescription>
      </StyledContentContainer>
    );
  }
}

ReviewItem.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  rating: PropTypes.number.isRequired,
  title: PropTypes.string,
  description: PropTypes.string
};

export default ReviewItem;



// WEBPACK FOOTER //
// ./src/components/ReviewItem/index.js